<div class="controls">
  <button
    nz-button
    nzType="default"
    nzShape="circle"
    (mousedown)="prevFrameHold.emit()"
    (mouseup)="stopHold.emit()"
    (mouseleave)="stopHold.emit()"
  >
    <i nz-icon nzType="left" nzTheme="outline"></i>
  </button>

  <div class="play-progress-wrapper" (click)="toggleAutoplay.emit()">
    <svg class="progress-ring" viewBox="0 0 36 36">
      <circle class="ring-bg" cx="18" cy="18" r="16" />
      <circle
        class="ring-progress"
        cx="18"
        cy="18"
        r="16"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="progressOffset"
      />
    </svg>

    <button
      nz-button
      nzShape="circle"
      nzSize="small"
      class="play-button"
      [ngClass]="{ playing: isAutoplaying }"
    >
      <i nz-icon [nzType]="isAutoplaying ? 'pause' : 'caret-right'" nzTheme="outline"></i>
    </button>
  </div>

  <button
    nz-button
    nzType="default"
    nzShape="circle"
    (mousedown)="nextFrameHold.emit()"
    (mouseup)="stopHold.emit()"
    (mouseleave)="stopHold.emit()"
  >
    <i nz-icon nzType="right" nzTheme="outline"></i>
  </button>
</div>
